import _lib from '../_lib';
import active from './active/index';
import {DataUploadNavigation} from '@/store/modules/fsm/messages';

export default ({tree,parent,api}) => {
  let regionName = 'uploadDeviceData';
  let activations = [
    {
      name: 'uploadDeviceData',
      test: api.messageIs(DataUploadNavigation)
    }
  ];
  let activeIndex = active;
  let readyToDormant = () => {};
  let func = _lib({regionName,activations,activeIndex,readyToDormant});
  return func({tree,parent,api});
};

